import { Component, Input, OnInit } from '@angular/core';
import { Handover } from 'src/app/interfaces/handover';
import { DialogService } from 'src/app/services/dialog.service';
import { HandoverService } from 'src/app/services/handover.service';
import { ImageService } from 'src/app/services/image.service';
import { SectionTouched } from '../../shared/section-touched.class';
import { Image } from 'src/app/interfaces/image';
import { HandoverImageComponent } from '../../handover-image/handover-image.component';
import { MatDialog } from '@angular/material/dialog';
import { HandoverRelation } from 'src/app/interfaces/handover-relation';
import { HANDOVER_TYPE_HO2_ID } from 'src/app/handover-constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-handover-detail-location-images',
  templateUrl: './handover-detail-location-images.component.html',
  styleUrls: ['./handover-detail-location-images.component.scss'],
  standalone: false,
})
export class HandoverDetailLocationImagesComponent
  extends SectionTouched
  implements OnInit
{
  @Input() handover: Handover | undefined;
  @Input() handoverRelation: HandoverRelation | undefined;
  @Input() readOnlyContent!: boolean;

  deliveryLocationImages: Image[] = [];
  imageLimit = 6;
  qtyImageRequired = 3;
  isLoadingImages = false;
  dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    public handoverService: HandoverService,
    public imageService: ImageService,
    public dialogService: DialogService,
    public dialog: MatDialog
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.handover) {
      this.getDeliveryLocationImages(
        this.handoverRelation && this.handoverRelation.handoverLocationId
          ? this.handoverRelation.handoverLocationId
          : this.handover!.handoverId!
      );
    }
  }

  attachImage(): void {
    if (this.handover) {
      this.imageService.endpointUrl = `${environment.urlBackend}/dhoapi/handovers/${this.handover.handoverId}/delivery-location/images`;
      const dialogRef = this.dialogService.openImageUploadDialog(
        this.handover.handoverId!,
        'Adjuntar foto o diagrama',
        500
      );
      dialogRef.afterClosed().subscribe((image) => {
        if (undefined != image) {
          this.deliveryLocationImages.push(image);
        }
      });
    }
  }

  getDeliveryLocationImages(handoverId: number): void {
    this.isLoadingImages = true;
    this.handoverService
      .getDeliveryLocationImages(handoverId)
      .subscribe((values: Image[]) => {
        this.deliveryLocationImages = values;
        this.isLoadingImages = false;
      });
  }

  deleteImage(image: Image, index: number): void {
    if (this.handover?.handoverId)
      this.imageService.endpointUrl = `${environment.urlBackend}/dhoapi/handovers/${this.handover.handoverId}/delivery-location/images`;
    const dialogRef = this.dialogService.openConfirmDialog(
      'Imagen de Entrega de Locación',
      `¿Está seguro de que desea eliminar la imagen?`
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (res) {
        this.isLoadingImages = true;
        this.imageService.deleteImage(image).subscribe((boolean) => {
          this.deliveryLocationImages.splice(index, 1);
          this.isLoadingImages = false;
        });
      }
    });
  }

  openImage(image: Image): void {
    const dialogRef = this.dialog.open(HandoverImageComponent, {
      width: '700px',
      height: '600px',
      hasBackdrop: false,
      autoFocus: false,
      data: {
        image: image,
        title: 'Entrega de Locación',
      },
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('Imagen de Entrega de Locación ha sido cerrada');
    });
  }
}
